//이벤트버스 사용을 설정함.
import Vue from "vue"
const EventBus = new Vue();
export default EventBus;
